/**************************************************
 * Nombre:       Tarjeta_Pedidos_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import img_def from '../../Recursos/img_defecto.png'


const Tarjeta_Pedidos_Producto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{border: 1, borderColor: theme.palette.primary.main + 50, p: 1, borderRadius: 2}}
        >

            <Grid container size={3}>
                <img src={item.img ? item.img : img_def} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid container size={9} sx={{pl: 1}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={12}>

                    <Grid container size={6}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        }}>{`Cant: ${item.cantidad}`}</Typography>
                    </Grid>

                    <Grid container size={6} sx={{justifyContent: 'flex-end', pb: 0.5}}>
                        <Typography sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        }}>{`Und ${item.presentacion}`}</Typography>
                    </Grid>

                    <Grid container size={12} sx={{mt: 0.5}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={12} sx={{mt: -0.5, mb: 0.5}}>
                        <Typography sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        }}>{`Marca: ${item.marca}`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={12} sx={{pl: 1}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 12,
                            fontWeight: 400
                        }}>{`Und: ${formatoMoneda(item.valor)}`}</Typography>
                    </Grid>

                    <Grid container size={6} sx={{justifyContent: 'flex-end'}}>
                        <Typography sx={{
                            fontSize: 14,
                            fontWeight: 600
                        }}>{`Total : ${formatoMoneda(item.cantidad * item.valor)}`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Pedidos_Producto    